// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Ye-N","select":"Header_select__3OMo0","clinic":"Header_clinic__1b_oM"};